/**
 * 课程内容
 * @description 课程内容
 * @author yly
 * @date 2023-9-12
 *  */
import React, {useEffect, useRef, useState} from 'react';
import { connect } from 'dva';
import {Tooltip, Tag, Form, Input, InputNumber, Select, Modal} from 'antd'
import { framework_tool, component_tool, utils_tool, } from '@/tool'
import { modelUtils } from "@/utils";
import './index.less'
import TextArea from "antd/lib/input/TextArea";
import {useUpdateEffect} from "ahooks";
let { WizContainer } = framework_tool;
let {
  WizButton, WizMenu, WizTable, Wizmessage
} = component_tool;

class WizClassifySelect extends WizContainer {

  componentName = 'WizClassifySelect';

  constructor(props) {
    super(props);
    this.state = {
      stateSelects: props.initSelects || [],
      data: {},
      rowData: new Date().getTime(),
      programContent: [],
      keywordInputList: [],
      selectedExamRows: [],//选择的课程考试
      selectedScheduleRows: [], //选择的课件
      inputValue: '',
      type: props.type,
    }
    this.defaultValue = props.value;

  }


  static defaultProps = {
    onChange: () => { },//点击modal 确定的回调方法
    value: [],//已选数据,
    modalProps: {},//modal的参数
    selectProps: {},//输入框的参数
    wizTreeSelectListProps: {},//WizTreeSelectList的参数
    apiProps: {},//调用分类接口的参数
    apiPath: 'questionType/nodeList',//api的redux动态模型的请求patg
    returnKey: false,//onChange返回数据是否需要key，默认返回对象
  };


  /**
   * 初始化时根据record判断是新增还是编辑
   */
  _componentDidMount() {

    const { value } = this.props;
    if (value?.length > 0) {
      let copyValue = value.map(item => {
        return {
          key: item.sort, id: item.id, sort: item.sort, type: item.type, list: item.list, ratio: item.ratio, keywordValue: item.keywordValue
        }
      })
      this.setState({ programContent: copyValue })
    }
    if (this.props.onClearContent) {
      this.props.onClearContent(this._onClear.bind(this))
    }
  }

  propsAndStateOnChange = {
    value: this._getValueOver.bind(this),
  }

  _getValueOver(nextProps, nextState) {
    const { value } = nextProps;
    if (value?.length > 0) {
      let copyValue = value.map(item => {
        return {
          ...item,
          key: item.sort, id: item.id, sort: item.sort, type: item.type, list: item.list, ratio: item.ratio, keywordValue: item.keywordValue
        }
      })
      nextState.programContent = copyValue
      return true;
    } else {
    }
    return false;
  }

  /**
   * 重置
   */
  _onClear = () => {
    let value = this.defaultValue
    if (value?.length > 0) {
      let copyValue = value.map(item => {
        return {
          key: item.sort, id: item.id, sort: item.sort, type: item.type, list: item.list, ratio: item.ratio, keywordValue: ''
        }
      })
      this.setState({ programContent: copyValue })
    } else {
      let copyValue = [...value]
      this.setState({ programContent: copyValue }, () => {
        this.forceUpdate()
      })
    }
  }
  handleMenuClick(e) {
    let { type } = this.props
    let { programContent } = this.state
    if (programContent?.length > 9) {
      Wizmessage.warning(`最多添加10个${type == 1 ? '失' : '得'}分规则`)
    } else {
      let { onChange, type } = this.props
      let data = {
        key: programContent.length + 1,
        sort: programContent.length + 1,
        ratio: '',
        type: type,
        list: []
      }
      console.log('提交  =====>', data)
      let content = JSON.parse(JSON.stringify(this.state.programContent))
      content.push(data)
      this.setState({ programContent: content, })
      let copyContent = JSON.parse(JSON.stringify(content))
      // onChange && onChange(this.formatList(copyContent))
    }
  }
  formatList = (content) => {
    let copyContent = [...content]
    // copyContent=copyContent.map(item =>{return ({ sort: item.sort, ratio: item.ratio, type: item.type, list: item.list })})
    return copyContent
  }
  submit = (data) => {
    let { onChange } = this.props
    console.log('提交  =====>', data)
    let content = JSON.parse(JSON.stringify(this.state.programContent))
    content.push(data)
    this.setState({ programContent: content, })
    let copyContent = JSON.parse(JSON.stringify(content))
    onChange && onChange(this.formatList(copyContent))
  }

  deleteRow = (record) => {
    let content = [...this.state.programContent]
    content = content.filter(x => x.key != record.key)
    content.forEach((item, index) => {
      item.sort = index + 1
    })
    this.setState({ programContent: content })
    let { onChange } = this.props
    onChange(content)
  }
  rankList = (list) => {
    let copyList = JSON.parse(JSON.stringify(list))
    copyList.forEach((item, index) => {
      item.orderNum = index + 1
    })
    return copyList
  }

  handleInputChange = (e, record) => {
    let inputWord = e.target.value
    let { onChange } = this.props
    let content = JSON.parse(JSON.stringify(this.state.programContent))
    content.forEach((item) => {
      if (item.key == record.key) {
        item.keywordValue = inputWord
      }
    })
    this.setState({ programContent: content, inputValue: '' })
    onChange && onChange(content)

  }
  handleInputConfirm = (record) => {
    // let reg = /^[\u4E00-\u9FA5\sA-Za-z0-9%.+-]+$/
    let inputWord = record.keywordValue
    // if (!reg.test(inputWord)) {
    //   wizNotice.error('请输入正确格式的关键词')
    //   return false;
    // }
    if (inputWord) {
      if (inputWord.trim().length == 0 || inputWord.trim().length > 50) {
        wizNotice.error('请输入正确格式的关键词，不能为空，且不能超过50个字')
        return false;
      }
      let { onChange } = this.props
      let content = JSON.parse(JSON.stringify(this.state.programContent))
      content.forEach((item) => {
        if (item.key == record.key) {
          item.list.push({ sort: record.list.length + 1, words: record.keywordValue })
          item.keywordValue = ''
        }
      })
      this.setState({ programContent: content, inputValue: '', })
      let copyContent = JSON.parse(JSON.stringify(content))
      onChange && onChange(content)
    }
  }
  ratioChange = (e, record) => {
    if (e.target.value && (e.target.value.toString().indexOf('.') > -1 || e.target.value > 100 || e.target.value < 0)) {

    } else {
      let { onChange } = this.props
      let content = JSON.parse(JSON.stringify(this.state.programContent))
      content.forEach(item => {
        if (item.key == record.key) {
          item.ratio = e.target.value
        }
      })
      this.setState({ programContent: content, inputValue: '' })
      onChange && onChange(content)
    }
  }

  modeChange = async (mode, modeValue, record) => {
    const key = 'wizCourseContent-modeChange';
    // 实际执行的代码回调
    const callback = async () => {
      console.log('modeChange', mode, modeValue, record, this.state.programContent)

      sessionStorage.setItem(key, Date.now())

      let { onChange } = this.props
      let content = JSON.parse(JSON.stringify(this.state.programContent))
      content.forEach(item => {
        if (item.key == record.key) {
          item.mode = mode
          item.modeValue = modeValue
        }
      })
      this.setState({ programContent: content, inputValue: '' })
      onChange && onChange(content)
    }
    const _callback = async () => {
      if(sessionStorage.getItem(key)) {
        await new Promise((resolve) => {
          setTimeout(async () => {
            resolve(await _callback());
          }, 50)
        })
      } else {
        callback().finally(() => sessionStorage.removeItem(key))
      }
    }
    await _callback()
  }

  editPromptWord = (record) => {
    let _ref
    Modal.confirm({
      title: '修改提示词',
      content: <TextArea ref={ref => _ref = ref} defaultValue={record?.promptWord}/>,
      onOk: () => {
        let content = JSON.parse(JSON.stringify(this.state.programContent))
        content.forEach((item, index) => {
          if (item.key == record.key) {
            item.promptWord = _ref?.state?.value
          }
        })
        this.setState({ programContent: content, inputValue: '' })
        let { onChange } = this.props
        onChange && onChange(content)
      },
    })
  }

  handleClose = (tag, record) => {

    let { onChange } = this.props
    let content = JSON.parse(JSON.stringify(this.state.programContent))
    console.log(content, 'content77')
    content.forEach((item) => {
      if (item.sort == record.sort) {
        item.list = item.list.filter(x => x.sort != tag.sort)
      }
    })
    this.setState({ programContent: content, inputValue: '', })
    onChange && onChange(content)
  }

  _render() {
    const { mateWay, scoreRule } = this.props

    const columns = [
      {
        title: '序号',
        dataIndex: 'sort',
        key: 'sort',
        width: 70
      },
      {
        title: '得分关键词',
        dataIndex: 'list',
        key: 'list',
        render: (text, record) => {
          return (
            <div className='keyword-input-box'>
              <Input
                className='keyword-input'
                // ref={this.saveInputRef}
                // type="text"
                // size="small"
                style={{ width: 130 }}
                placeholder='点击添加关键词'
                value={record.keywordValue}
                onChange={(e) => this.handleInputChange(e, record)}
                onPressEnter={() => this.handleInputConfirm(record)}
              />
              <div className='tag-box'>
                {text.map((tag, index) => {
                  const isLongTag = tag.words.length > 20;
                  const tagElem = (
                    <Tag className='tag-item' key={tag.sort} closable={true} onClose={() => this.handleClose(tag, record)}>
                      {isLongTag ? `${tag.words.slice(0, 20)}...` : tag.words}
                    </Tag>
                  );
                  return isLongTag ? (
                    <Tooltip title={tag.words} key={tag.sort}>
                      {tagElem}
                    </Tooltip>
                  ) : (
                    tagElem
                  );
                })}
              </div>
            </div>
          )
        },
      },
      mateWay == 0 || scoreRule !== 1 ? {
        title: '得分权重（%）',
        dataIndex: 'ratio',
        key: 'ratio',
        width: 170,
        render: (text, record) => {
          return (
            <Input type='number' value={record.ratio}
                   placeholder='点击输入正整数'
                   onChange={(value) => this.ratioChange(value, record)}></Input>
          )
        }
      } : undefined,
      mateWay == 3 ? {
        title: '计分模式',
        dataIndex: '_mode',
        key: '_mode',
        width: 240,
        render: (_, record) => {
          const {mode, modeValue} = record || {}
          return <ModeInput scoreRule={scoreRule} mode={mode} modeValue={modeValue} modeChange={(mode, modeValue) => this.modeChange(mode, modeValue, record)}/>
        }
      } : undefined,
      {
        title: '操作',
        dataIndex: 'action',
        key: 'action',
        width: 160,
        render: (text, record) => (
          <span style={{display: 'flex', gap: 10}}>
            <a onClick={e => this.deleteRow(record)}> 删除</a>
            {mateWay == 3 ? <a onClick={e => this.editPromptWord(record)}>设置提示词</a> : undefined}
          </span>
        ),
      },
    ].filter(item => !!item);
    const lossColumns = [
      {
        title: '序号',
        dataIndex: 'sort',
        key: 'sort',
        width: 70
      },
      {
        title: '失分关键词',
        dataIndex: 'list',
        key: 'list',
        render: (text, record) => {
          return (
            <div className='keyword-input-box'>
              <Input
                className='keyword-input'
                // ref={this.saveInputRef}
                // type="text"
                // size="small"
                // style={{ width: 78 }}
                placeholder='点击添加关键词'
                value={record.keywordValue}
                onChange={(e) => this.handleInputChange(e, record)}
                onPressEnter={() => this.handleInputConfirm(record)}
              />
              <div className='tag-box'>
                {text.map((tag, index) => {
                  const isLongTag = tag.words.length > 20;
                  const tagElem = (
                    <Tag className='tag-item' key={tag.sort} closable={true} onClose={() => this.handleClose(tag, record)}>
                      {isLongTag ? `${tag.words.slice(0, 20)}...` : tag.words}
                    </Tag>
                  );
                  return isLongTag ? (
                    <Tooltip title={tag.words} key={tag.sort}>
                      {tagElem}
                    </Tooltip>
                  ) : (
                    tagElem
                  );
                })}
              </div>
            </div>
          )
        },
      },
      {
        title: '失分权重（%）',
        dataIndex: 'ratio',
        key: 'ratio',
        width: 170,
        render: (text, record) => {
          return (
            <Input type='number' value={record.ratio}
                   placeholder='点击输入正整数'
                   onChange={(value) => this.ratioChange(value, record)}></Input>
          )
        }
      },
      {
        title: '操作',
        dataIndex: 'action',
        key: 'action',
        width: 160,
        render: (text, record) => (
          <span>
            <a onClick={e => this.deleteRow(record)}> 删除</a>
          </span>
        ),
      },
    ];
    let { type } = this.props
    return (
      <div className='get-loss-rule'>
        <WizButton hidden={!!this.props.hiddenAddBtn} type="primary" onClick={this.handleMenuClick.bind(this)}>
          添加规则
        </WizButton>
        {/* <span className='rule-tips'>最多添加10个规则，每个规则最多添加20个关键词，每个关键词最多20字，支持中文、数字、字母及常见字符，按回车键可添加一个关键词； */}
        {/*   {type == 1 ? '所有失分规则的失分权重总和必须小于等于100' : '所有得分规则的得分权重总和必须等于100'}</span> */}
        <div className="table-row" key={'program_content_' + this.state.time}>
          <WizTable bordered pagination={false} columns={type == 1 ? lossColumns : columns} dataSource={this.state.programContent} />
        </div>
      </div>)
  }
}

const ModeInput = ({disabled, scoreRule, mode, modeValue, modeChange}) => {
  const DEFAULT_MODE = 0, DEFAULT_MODE_VALUE = 6;
  const ref_select = useRef()
  const [dataDefault] = useState({mode, modeValue})
  const [data, setData] = useState({mode, modeValue})

  useEffect(() => {
    const {mode, modeValue} = data
    if(!!mode || !!modeValue) return
    // 为空时初始化一个默认值
    setData({mode: DEFAULT_MODE, modeValue: DEFAULT_MODE_VALUE})
  }, [])

  useUpdateEffect(() => {
    const {mode, modeValue} = data
    modeChange && modeChange(mode, modeValue)
  }, [data]);

  useUpdateEffect(() => {
    if(scoreRule === 0) {
      return;
    }
    const {mode, modeValue} = dataDefault
    if (data?.mode !== 0) {
      if ([undefined, null].includes(mode)) {
        setData(data => ({...data, mode: DEFAULT_MODE, modeValue: DEFAULT_MODE_VALUE}))
      } else if (mode === 0) {
        setData(data => ({...data, mode: mode, modeValue: modeValue}))
      }
    }
  }, [scoreRule])


  return (
    <Input
      disabled={disabled}
      onChange={e => setData({mode: data.mode, modeValue: e.target.value})}
      addonBefore={
        <Select
          ref={ref_select}
          style={{ width: 90 }}
          disabled={disabled || (scoreRule !== 0 && data?.mode === 0)}
          value={data?.mode}
          onChange={e => {
            setData({mode: e, modeValue: data.mode === e ? data.modeValue : DEFAULT_MODE_VALUE})
            // 规避选择后变蓝问题
            ref_select.current?.blur?.()
          }}
        >
          <Option value={0}>分数线</Option>
          <Option value={1}>实际分</Option>
        </Select>
      }
      value={data.modeValue}
    />
  )
}


const mapStateToProps = (state, ownProps) => {
  const { questionType } = state;
  const { apiProps } = ownProps;

  const treeData = modelUtils.getModelEntity(questionType, `questionType@treeData${apiProps && apiProps.type || ''}`);
  const load = modelUtils.getLoadingState(state, "selects");

  return {
    treeData,
    ...load
  }
};

const options = { withRef: true };
export default Form.create()(connect(mapStateToProps, null, null, options)(WizClassifySelect));
export {
  ModeInput,
}
